"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductType;
(function (ProductType) {
    ProductType["SUBSCRIPTION"] = "SUBSCRIPTION";
    ProductType["STORAGE_UPGRADE"] = "STORAGE_UPGRADE";
    ProductType["TRIAL"] = "TRIAL";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//# sourceMappingURL=ProductType.js.map